<div class="cf-dlg">
  <div class="cf-dlg-header">
    <div class="cf-dlg-icon"><mat-icon>work</mat-icon></div>
    <div class="pj-header-text">
      <h2 class="cf-dlg-title">{{ isTicket ? 'Proyecto de la factura simplificada' : 'Proyecto de la factura' }}</h2>
      <p class="cf-dlg-subtitle" *ngIf="documentNumber">{{ documentNumber }}</p>
    </div>
    <button mat-icon-button class="cf-dlg-close" (click)="closeDialog()" [disabled]="saving" aria-label="Cerrar">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <ng-container *ngIf="!loading && !saving; else busyTpl">
    <div class="cf-dlg-body">
      <app-autocomplete *ngIf="projectConfig" [control]="projectControl" [config]="projectConfig"></app-autocomplete>
    </div>

    <div class="cf-dlg-footer">
      <button mat-stroked-button class="cf-dlg-btn-danger" *ngIf="currentProjectUid" (click)="removeProject()">
        <mat-icon>delete</mat-icon> Quitar proyecto
      </button>
      <button mat-stroked-button class="cf-dlg-btn-secondary" (click)="closeDialog()">Cancelar</button>
      <button mat-flat-button class="cf-dlg-btn-primary" (click)="save()" [disabled]="!hasChanges">
        <mat-icon>save</mat-icon> Guardar
      </button>
    </div>
  </ng-container>

  <ng-template #busyTpl>
    <app-loading-state [message]="saving ? 'Guardando proyecto…' : 'Cargando proyectos…'"></app-loading-state>
  </ng-template>
</div>
